import { render } from "./ExploreBrands.vue?vue&type=template&id=20c8c8a6"
import script from "./ExploreBrands.vue?vue&type=script&lang=js"
export * from "./ExploreBrands.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__